import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import logo from '../../images/footerLogo.svg';
import hamburgerIcon from '../../images/ic_menu.svg';
import closeIcon from '../../images/ic_close.svg';

export const AppHeader = ({ items = [], onLogout }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <Bar>
        <BrandLink to={items[0]?.to || '/'} onClick={close}>
          <Logo src={logo} alt="SmrtStats" />
        </BrandLink>
        <Toggle
          type="button"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <img src={open ? closeIcon : hamburgerIcon} alt="" />
        </Toggle>
      </Bar>
      {open && (
        <DrawerOverlay onClick={close}>
          <Drawer onClick={(e) => e.stopPropagation()}>
            {items.map((item) => (
              <DrawerItem key={item.to} to={item.to} end onClick={close}>
                {item.label}
              </DrawerItem>
            ))}
            {onLogout && (
              <LogoutItem
                type="button"
                onClick={() => {
                  close();
                  onLogout();
                }}
              >
                Log out
              </LogoutItem>
            )}
          </Drawer>
        </DrawerOverlay>
      )}
    </>
  );
};

export default AppHeader;

const Bar = styled.header`
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(env(safe-area-inset-top, 0px) + 16px) 20px 16px;
  background: ${(props) => props.theme.black};
  border-bottom: 1px solid ${(props) => props.theme.lines};
`;

const BrandLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
`;

const Logo = styled.img`
  width: 106px;
  display: block;
`;

const Toggle = styled.button`
  background: transparent;
  border: none;
  padding: 8px;
  margin: -8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    width: 28px;
    height: 28px;
    display: block;
  }
`;

const DrawerOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${(props) => props.theme.sidebar};
  backdrop-filter: blur(5px);
  z-index: 19;
`;

const Drawer = styled.nav`
  position: absolute;
  top: calc(env(safe-area-inset-top, 0px) + 64px);
  left: 0;
  right: 0;
  background: ${(props) => props.theme.sidebar};
  border: 1px solid ${(props) => props.theme.lines};
  border-top: none;
  box-shadow: 0px 4px 40px ${(props) => props.theme.green};
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 4px;
`;

const DrawerItem = styled(NavLink)`
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 14px;
  border-radius: 8px;
  font-family: 'SatoshiMedium', sans-serif;
  font-size: 16px;
  letter-spacing: 0.5px;
  color: ${(props) => props.theme.blueish};
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.white};
  }

  &.active {
    color: ${(props) => props.theme.green};
    background: ${(props) => props.theme.lines};
  }
`;

const LogoutItem = styled.button`
  margin-top: 8px;
  height: 44px;
  padding: 0 14px;
  background: transparent;
  border: 1px solid ${(props) => props.theme.lines};
  border-radius: 8px;
  font-family: 'SatoshiMedium', sans-serif;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${(props) => props.theme.blueish};
  text-align: left;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.white};
  }
`;
